// Family -> dot colour, shared by PermName and RoleFlow. Known families get
// a distinct hue; an unrecognised group (future permission family) still
// renders sensibly via the default rather than throwing or going blank.
const GROUP_DOT_COLOR: Record<string, string> = {
    billing: 'bg-emerald-500',
    products: 'bg-sky-500',
    practices: 'bg-orange-500',
    users: 'bg-violet-500',
    apps: 'bg-rose-500'
};

const GROUP_RING_COLOR: Record<string, string> = {
    billing: 'border-emerald-400',
    products: 'border-sky-400',
    practices: 'border-orange-400',
    users: 'border-violet-400',
    apps: 'border-rose-400'
};

// Same families, text-weight tints; used by Chain's terminal permission node.
const GROUP_TEXT_COLOR: Record<string, string> = {
    billing: 'text-emerald-700',
    products: 'text-sky-700',
    practices: 'text-orange-700',
    users: 'text-violet-700',
    apps: 'text-rose-700'
};

const DEFAULT_DOT_COLOR = 'bg-gray-400';
const DEFAULT_RING_COLOR = 'border-gray-300';
const DEFAULT_TEXT_COLOR = 'text-gray-500';

export function permissionGroupDotColor(group: string): string {
    return GROUP_DOT_COLOR[group] ?? DEFAULT_DOT_COLOR;
}

export function permissionGroupRingColor(group: string): string {
    return GROUP_RING_COLOR[group] ?? DEFAULT_RING_COLOR;
}

export function permissionGroupTextColor(group: string): string {
    return GROUP_TEXT_COLOR[group] ?? DEFAULT_TEXT_COLOR;
}
